import { api } from './client.js';

export const mfaApi = {
  challenge: (code) => api.post('/auth/mfa/challenge', { code }),
  enroll: () => api.post('/auth/mfa/enroll'),
  verifyEnrollment: (code) => api.post('/auth/mfa/enroll/verify', { code }),
  disable: () => api.post('/auth/mfa/disable')
};
